export enum NotificationType {
  SMS = 'SMS',
  WHATSAPP_AUTO = 'WHATSAPP_AUTO',
  WHATSAPP_MANUAL = 'WHATSAPP_MANUAL',
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/notification-type.enum.ts